import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Addon, OrderFormFieldInterface } from '@galaxy/marketplace-apps/v1';
import { AppPrice, AppPrices, FulfillmentOrderConfig } from '@vendasta/marketplace-apps';
import { OrderForm } from '@vendasta/marketplace-apps/v1';
import { Product } from '../../shared/product';
import { FormPreviewDialogComponent } from '../form-preview/form-preview.component';
import { MarketingType, PersonaType } from '../product-details-v2.interface';
@Component({
  selector: 'store-product-info',
  templateUrl: './product-info.component.html',
  styleUrls: ['./product-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ProductInfoComponent {
  @Input() product: Product;
  @Input() partnerId: string;
  @Input() marketId: string;
  @Input() appPrice: AppPrice;
  @Input() addonPrices: AppPrices[];
  @Input() currency: string;
  @Input() isAddon: boolean;
  @Input() marketingType: MarketingType = MarketingType.Partner;
  @Input() personaType: PersonaType = PersonaType.Partner;
  @Input() orderForm: OrderForm;
  @Input() usesActivationSpecificEntryUrl: boolean;
  @Input() fulfillmentOrderConfig: FulfillmentOrderConfig;
  @Output() addonSelected = new EventEmitter<string>();
  @Output() editionTabSelected = new EventEmitter<boolean>();
  constructor(public dialog: MatDialog) {}

  private addons: Addon[];
  marketingTypeEnum = MarketingType;

  showRequiredFormsPopover = false;

  onAddonSelected(addonId: string): void {
    this.addonSelected.emit(addonId);
  }

  getAddons(): Addon[] {
    if (!this.addons) {
      this.addons = this.product.addons.map((addon) => Addon.fromApi(addon));
    }
    return this.addons;
  }

  openOrderFormPreview(): void {
    let fieldList: OrderFormFieldInterface[];
    fieldList = this.orderForm?.orderForm?.map((component) => {
      return {
        label: component.label,
        id: component.id,
        type: component.type,
        options: component.options,
        description: component.description,
        required: component.required,
        uploadUrl: component.uploadUrl,
        prefix: component.prefix,
        suffix: component.suffix,
        regexValidator: component.regexValidator,
        regexErrorMessage: component.regexErrorMessage,
        allowMultiples: component.allowMultiples,
        allowDuplicates: component.allowDuplicates,
        maxChoices: component.maxChoices,
        forOfficeUseOnly: component.forOfficeUseOnly,
        officeEditableOnly: component.officeEditableOnly,
        optionsWithLabels: component.optionsWithLabels,
      };
    });
    if (this.usesActivationSpecificEntryUrl) {
      if (fieldList) {
        fieldList.unshift({
          label: 'Custom Entry Url',
          id: 'custom-entry-url-',
          type: 'text',
          options: [],
          description: '',
          required: true,
          uploadUrl: '',
          prefix: '',
          suffix: '',
          regexValidator: '^(http://|https://).*',
          regexErrorMessage: 'Not in correct format. Should be prefixed with https or http.',
        });
      } else {
        fieldList = [
          {
            label: 'Custom Entry Url',
            id: 'custom-entry-url-',
            type: 'text',
            options: [],
            description: '',
            required: true,
            uploadUrl: '',
            prefix: '',
            suffix: '',
            regexValidator: '^(http://|https://).*',
            regexErrorMessage: 'Not in correct format. Should be prefixed with https or http.',
          },
        ];
      }
    }
    this.dialog.open(FormPreviewDialogComponent, {
      width: '600px',
      data: {
        app: { ...this.product },
        commonFormRequiredFields: this.orderForm.commonFormRequiredFields || [],
        customFormFields: fieldList || [],
      },
      panelClass: 'order-form-preview-modal',
    });
  }

  openFulfillmentFormPreview(): void {
    this.dialog.open(FormPreviewDialogComponent, {
      width: '600px',
      data: {
        app: {
          ...this.product,
          orderForm: {
            // use fulfillment form for previewing
            ...this.fulfillmentOrderConfig?.fulfillmentForm,
          },
        },
        commonFormRequiredFields: this.fulfillmentOrderConfig?.fulfillmentForm?.commonFormRequiredFields || [],
        customFormFields: this.fulfillmentOrderConfig?.fulfillmentForm?.orderForm || [],
        title: 'Fulfillment form preview',
      },
      panelClass: 'order-form-preview-modal',
    });
  }
}
